import React, { Component } from "react";
import styled from "styled-components";

const Div = styled.div`
  background-color: #f5f9ff;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8rem 0 5rem 0;

  .law-title-container {
    width: 120rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .law-title {
      position: relative;
      font-size: 2.8rem;
      font-weight: bold;
      margin-bottom: 4.6rem;

      &::after {
        position: absolute;
        content: "";
        bottom: -1.6rem;
        left: 0;
        width: 6.4rem;
        height: 0.8rem;
        background-image: linear-gradient(to right, #1677ff, #31afff);
      }
    }

    .read-more {
      font-size: 1.4rem;
      color: #666666;
      cursor: pointer;
      position: relative;

      &::after {
        position: absolute;
        content: "";
        top: 0.4rem;
        right: -1rem;
        width: 1rem;
        height: 1rem;
        border-right: 1px solid #999999;
        border-top: 1px solid #999999;
        transform: rotate(45deg);
      }
    }
  }

  .law-contents-container {
    width: 120rem;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 2rem;

    .law-content-container {
      background-color: #ffffff;
      width: 38rem;
      height: 13rem;
      border-radius: 0.4rem;
      padding: 3rem 2rem 0 2rem;
      display: flex;
      flex-direction: column;
      cursor: pointer;
      transition: all 100ms ease-in-out;

      &:hover {
        background-color: #1677ff;

        .law-content {
          color: #ffffff;
        }

        .law-time {
          color: #ffffff;
        }
      }

      .law-content {
        color: #333333;
        font-size: 1.6rem;
        font-weight: bold;
      }

      .law-time {
        color: #999999;
        font-size: 1.4rem;
      }
    }
  }
`;

class LawRegulation extends Component {
  state = {
    lawDatas: [
      {
        lawTitle: "关于新增《景区服务行业管理规范》公告通知",
        lawTime: "2019-01-22",
      },
      {
        lawTitle: "关于印发《标准设备采购招标文件》等五个标准招标文件的通知",
        lawTime: "2019-01-22",
      },
      {
        lawTitle: "关于《中华人民共和国招标投标法(修订草案公开征求意见稿)》",
        lawTime: "2019-01-22",
      },
      {
        lawTitle: "评标专家和评标专家库管理暂行办法",
        lawTime: "2019-01-22",
      },
      {
        lawTitle: "关于新增《景区服务行业管理规范》公告通知",
        lawTime: "2019-01-22",
      },
      {
        lawTitle: "中华人民共和国招标投标法实施条例(2019年修订)",
        lawTime: "2019-01-22",
      },
    ],
  };

  render() {
    return (
      <Div>
        <div className="law-title-container">
          <div className="law-title">政策法规</div>
          <div className="read-more">查看更多</div>
        </div>
        <div className="law-contents-container">
          {this.state.lawDatas.map((data, index) => (
            <div key={`lawContent-${index}`} className="law-content-container">
              <div className="law-content">{data.lawTitle}</div>
              <div className="law-time">{data.lawTime}</div>
            </div>
          ))}
        </div>
      </Div>
    );
  }
}

export default LawRegulation;
